var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('fragment',[(_vm.showLinkEventModal)?_c('li',{on:{"click":_vm.run}},[_c('v-icon',{attrs:{"left":"","color":"light-blue"}},[_vm._v("ter-paperclip")]),_vm._v(" Připojení události ")],1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }